module.exports = __webpack_public_path__ + "media/images/employees/bernadett-324eea5c0d539ad563de2b63a2889418.png";